// 递归处理数组
// 参数：需要处理的数组array，处理每一个数组对象以及子集对象的方法fn, 子集key 子集字段不统一的时候，支持数组传参，遍历处理子集
export const repeatCb = (array, fn, childStr = 'children') => {
  let repeat = arr => {
    arr.forEach(el => {
      fn(el)
      if (Array.isArray(childStr)) {
        childStr.forEach(cd => {
          if (el.hasOwnProperty(cd)) {
            if (el[cd]) repeat(el[cd])
          }
        })
      } else {
        if (el[childStr]) repeat(el[childStr])
      }
    });
  }
  repeat(array)
}

export const deepClone = (origin) => {
  let type = Object.prototype.toString.call(origin)
  let copy
  if (type === '[object Array]') {
    copy = []
    for (let i = 0, len = origin.length; i < len; i++) {
      copy.push(deepClone(origin[i]))
    }
  } else if (type === '[object Object]') {
    copy = {}
    for (let key in origin) {
      copy[key] = deepClone(origin[key])
    }
  } else { // 基本数据类型直接返回
    return origin
  }
  return copy
}

/**
 * @description 数组分割方式：用于将数组中元素以特定长度分割为多个小数组
 * @param {Array} a 待分割的原始数组
 * @param {Number} s 数组分割步长<=>每s个元素分割为一组
 * @returns {Array} 返回分割后的二维数组，二维数组中的元素为s个数据组成的小数组
 */
export const arrayChunk = (a, s = 10) => {
  let arr = []
  let t = []
  let i = 0
  do {
    for (let j = 0; j < s; j++) {
      let idx = i + j
      if (idx < a.length) t.push(a[idx])
      else break
    }
    i += s
    arr.push(t)
    t = []
  } while (i < a.length)
  return arr
}

// 获取store中的list类型的数据
export const getStoreDispatchListData = async function (key, dispatchName, options = {}) { // key须用.拼接
  let keyStr = key.split('.').map(el => `["${el}"]`).join('')
  if (!eval(`this.$store.state${keyStr}`).length) { await this.$store.dispatch(dispatchName, options) }
  return eval(`this.$store.state${keyStr}`)
}

// 拼接用户画像字符串
export const jointUserPf = (arr, key) => {
  if (!arr || arr.length == 0) return ''
  if (arr.length == 1) return arr[0].list.map(ele => ele[key]).join('+') // 一个中多个属性时不显示括号
  return arr.map(cur => {
    let str = cur.list.map(ele => ele[key]).join('+')
    return cur.list.length == 1 ? str : `(${str})` // 一个属性时不展示括号
  }).join(' 或 ')
}

/**
 * @abstract 通用异步区域树组件搜索结果关键字高亮方法
 * 20220808优化:忽略关键字大小写匹配
 * @param str 原始字符串
 * @param keyword 待高亮的搜索关键字
 * @returns 返回关键字增加高亮样式后的模板字符串
 */
export const highlightKeyword = (str, keyword) => {
  // let reg = new RegExp(keyword, 'g')
  // let replaceStr = `<span class="zone_key_word">${keyword}</span>`
  // str = str.replace(reg, replaceStr)
  // return str
  let lcn = str.toLowerCase() // 先转为小写
  let lck = keyword.toLowerCase()
  let pt = lcn.indexOf(lck) // 关键字出现位置
  while (pt > -1) { // 逐一进行关键字匹配替换
    let oriKw = str.slice(pt, pt + lck.length)
    str = str.substring(0, pt) + '<span class="zone_key_word">' + oriKw + '</span>' + str.substring(pt + oriKw.length)
    let nfrom = pt + 35 + oriKw.length // 重新计算关键字开始检索的位置
    lcn = str.toLowerCase()
    pt = lcn.indexOf(lck, nfrom)
  }
  return str
}

/**
 * @abstract 浮点数转为整数方法
 * @param {Number} arg1 第一个待转换数字
 * @param {Number} arg2 第二个待转换数字
 * @returns {Object} 返回转换为整数后的数字数组与指数组成的数组
 */
export const toInteger = (arg1, arg2) => {
  let frac1
  let frac2
  try { frac1 = arg1.toString().split('.')[1].length } catch (e) { frac1 = 0 }
  try { frac2 = arg2.toString().split('.')[1].length } catch (e) { frac2 = 0 }
  let exp = Math.pow(10, Math.max(frac1, frac2))
  return [[arg1 * exp, arg2 * exp], exp]
}

/**
 * @abstract 较为精确的加法运算方法
 * @param {Number} arg1 第一个加数
 * @param {Number} arg2 第二个加数
 * @returns {Number} 返回较为精确的加法运算结果
 */
export const exactAdd = (arg1, arg2) => {
  const [intArs, exp] = toInteger(arg1, arg2)
  return (intArs[0] + intArs[1]) / exp
}

/**
 * 复制文本到剪切板的兼容性实现
 * @param {String} source 待复制的原始文本
 * @returns 复制完成返回true,复制失败抛出异常
 */
export async function uniCopy(source) {
  if (window.isSecureContext && navigator.clipboard && navigator.permissions) {
    /**
     * 使用系统剪切板(仅在支持的浏览器的https域名下可用,Firefox不支持 )
     ** https://developer.mozilla.org/zh-CN/docs/Web/API/Clipboard_API
     */
    const permitStatus = await navigator.permissions.query({ name: 'clipboard-write' })
    switch (permitStatus.state) {
      case 'granted':
        await navigator.clipboard.writeText(source)
        return true
      case 'prompt':
        console.warn('等待用户授权剪切板写入权限')
        await navigator.clipboard.writeText(source)
        break
      case 'denied':
        throw new Error('用户拒绝剪切板写入')
    }
  }

  if (document.execCommand) {
    return await new Promise((resolve, reject) => {
      const input = document.createElement('input')
      input.sytle = 'position:fixed;left:0px;top:0px;z-index:-100;height:0px'
      input.value = source
      document.body.appendChild(input)
      input.select()
      const exe = document.execCommand('copy')
      document.body.removeChild(input)
      if (exe) {
        resolve(true)
      } else {
        reject(new Error('浏览器不支持复制功能'))
      }
    })
  }
}

/**
 * javascript生成唯一id
 * @param {Number} len uuid长度,默认20位
 */
export function jsUuid() {
  let d = new Date().getTime()
  let uuid = 'xxxxxxxxxx4xxyxxxxxx'.replace(/[xy]/g, function (c) {
    let r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16)
  })
  return uuid
}

/**
 * 利用Promise竞速功能实现的简易异步请求超时函数，
 ** 缺点：虽能在指定时间范围内抛出错误，但并不会终止已发出的请求。
 * @param {Promise} request 异步API请求
 * @param {Number} timeout 超时时间
 * @param {String} timeoutMessage 超时提示消息
 * @returns
 */
export function waitWithTimeout(request, timeout, timeoutMessage = 'timeout') {
  let timer
  // 将超时写成一个Promise，然后通过Promise.race与API请求进行竞速，实现“过时不候”的接口超时功能
  const timeoutPromise = new Promise((_, reject) => {
    timer = setTimeout(() => {
      reject(timeoutMessage)
    }, timeout)
  })
  return Promise.race([timeoutPromise, request]).finally(() => {
    // 清除定时器
    clearTimeout(timer)
  })
}

// window.requestAnimationFrame 降级处理(兼容不支持requestAnimationFrame的浏览器)
function animationFrame (callback) {
  let tid = setTimeout(callback, 1000 / 60)
  return tid
}
function cancelFrame(id) {
  clearTimeout(id)
}
export const callAnimation = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || animationFrame

export const cancelAnimation = window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cancelFrame

// 获取字符串中的中文字符
export function getChineseCharacters(str) {
  return str.match(/[\u4e00-\u9fa5]/g).join('')
}
// 获取字符串中的非中文字符
export function getNonChineseCharacters(str) {
  return str.match(/[^\u4e00-\u9fa5]/g).join('')
}

